import React, { ReactNode } from 'react';
import breakpoints from 'src/integration/styles/breakpoints';
import DesktopNavigation from 'src/presentation/components/Navigation/DesktopNavigation';
import MobileNavigation from 'src/presentation/components/Navigation/MobileNavigation';
import PageHeader from 'src/presentation/components/PageHeader';
import useViewport from 'src/toolkit/utils/useViewport';
import styled, { css } from 'styled-components';

interface ComponentProps {
  children: ReactNode;
  site: string;
  pageName?: string;
}

const Root = styled.div`
  ${() => css``}
`;

const Content = styled.div`
  ${() => css`
    margin: 2rem 1rem;

    ${breakpoints.desktop`
      margin: auto;
      max-width: 82.5rem;
    `}
  `}
`;

const Layout = ({ site, pageName, children }: ComponentProps) => {
  const { isMobile, isDesktop } = useViewport();

  const renderPageTitle = () => {
    if (!pageName) {
      return <PageHeader title={`${site}`} />;
    }

    return <PageHeader title={`${site}: ${pageName}`} />;
  };

  return (
    <Root>
      {isDesktop && <DesktopNavigation />}
      {isMobile && <MobileNavigation pageName={pageName} site={site} />}

      <Content>
        {isDesktop && renderPageTitle()}
        {children}
      </Content>
    </Root>
  );
};

export default Layout;
